// Fuente única del semáforo de 8 estados (labels + colores unificados para toda la app)
export const SEMAFORO_COLORS = {
  green:     { bg: "#D1FAE5", text: "#059669", label: "Activo con hitos", emoji: "🟢", hex: "#10B981" },
  blue:      { bg: "#DBEAFE", text: "#2563EB", label: "Acompañar", emoji: "🔵", hex: "#3B82F6" },
  purple:    { bg: "#E9D5FF", text: "#7C3AED", label: "Finalizado", emoji: "🟣", hex: "#8B5CF6" },
  orange:    { bg: "#FFEDD5", text: "#EA580C", label: "Sin actividad", emoji: "🟠", hex: "#F97316" },
  yellow:    { bg: "#FEF3C7", text: "#D97706", label: "Activo sin hitos", emoji: "🟡", hex: "#FBBF24" },
  red:       { bg: "#FEE2E2", text: "#DC2626", label: "En riesgo", emoji: "🔴", hex: "#EF4444" },
  dark_gray: { bg: "#E5E7EB", text: "#374151", label: "Inactivo", emoji: "⚫", hex: "#6B7280" },
  black:     { bg: "#1F2937", text: "#F9FAFB", label: "No iniciado", emoji: "⬛", hex: "#111827" }
};
